module.exports = __webpack_public_path__ + "static/media/16.c9c77ccc.png";